import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { cloneDeep, isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalaryIndustry from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import IndicatorTable from '../../indicator-table';
import Table from './table';
import Explain from './explain';
import ExplainPDF from './explain-pdf';

interface IProps {}
interface IState {}

const TablePDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData, tableHead, tableLeft, tableRight } = moSalaryIndustry;

  const calcLog = () => {
    const leftArr: any[] = cloneDeep(tableLeft.slice(27));
    const rightArr: any[] = cloneDeep(tableRight.slice(27));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(leftArr.length / 27); i += 1) {
      const leftData = leftArr.slice(27 * i + 27 * i, 27 * i + 27 * i + 27);
      const rightData = rightArr.slice(27 * i + 27 * i, 27 * i + 27 * i + 27);

      text.push(
        <PDF key={i}>
          <section className="salary-up-pdf_1010">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-salary-1001">
              <section className="title-1001">
                <Title title="涨薪率 - 按行业" bigTitle="人力指标" />
              </section>

              <IndicatorTable type="行业" tableHead={tableHead}
                tableLeft={leftData} tableRight={rightData} />

              {i === Math.floor(leftArr.length / 27) ? (
                <>
                  {tableLeft.length % 27 <= 20 ? <Explain /> : null}
                </>
              ) : null}
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  useEffect(() => {
    // console.log('table left -- ', toJS(tableLeft));
    // console.log('table right -- ', toJS(tableRight));

    return () => {};
  }, []);

  return (
    <>
      <Table />
      {tableRight.length > 27 ? calcLog() : null}
      {tableLeft.length % 27 > 20 ? <ExplainPDF /> : null}
    </>
  );
};

export default observer(TablePDF);
